import React from "react";

export type FacebookLogoProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 15,
    height: 15,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 60,
    height: 60,
  },
};

export const FacebookLogo = React.forwardRef<SVGSVGElement, FacebookLogoProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "black" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];

    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 30 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 15.0903C29.9997 12.2238 29.178 9.41743 27.6323 7.0034C26.0865 4.58938 23.8814 2.66881 21.2781 1.46906C18.6747 0.269322 15.7821 -0.159348 12.9427 0.233803C10.1033 0.626953 7.43598 1.82546 5.25655 3.68743C3.07713 5.54941 1.47686 7.99687 0.645198 10.7401C-0.186464 13.4833 -0.214691 16.4073 0.56386 19.1661C1.34241 21.9248 2.89514 24.4027 5.03821 26.3064C7.18128 28.2101 9.82495 29.4599 12.6562 29.9078V19.4266H8.8475V15.0903H12.6562V11.7853C12.6562 8.02656 14.8962 5.94906 18.3212 5.94906C19.4464 5.9652 20.569 6.06296 21.68 6.24156V9.93406H19.7875C19.2178 9.85844 18.6414 10.0122 18.185 10.3614C17.7286 10.7107 17.4296 11.2269 17.3538 11.7966C17.3323 11.9561 17.329 12.1175 17.3438 12.2778V15.0903H21.5L20.835 19.4266H17.335V29.9078C20.865 29.3515 24.0805 27.5532 26.4024 24.8367C28.7243 22.1202 30.0001 18.6639 30 15.0903Z"
          fill={color}
        />
      </svg>
    );
  }
);

FacebookLogo.displayName = "FacebookLogo";
